import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import moment from 'moment';
import { Dispatch, SetStateAction } from 'react';

import { BlogData } from '../types/General';

interface BlogDetailModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  blog: BlogData;
}

export default function BlogDetailModal({ open, onClose, setOpen, blog }: BlogDetailModalProps) {
  return (
    <Modal
      className="modal fcDetail_modal"
      id="fcDetailModal"
      aria-labelledby="fcDetail-modal-title"
      aria-describedby="fcDetail-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Blog Details</h2>
          </div>
          <div className="fcustomer_info gap_m">
            <div className="left_s">
              <figure className="blog_dtl_img">
                <img
                  style={{
                    maxHeight: '',
                  }}
                  src={blog?.image || '/static/images/blog_image.jpg'}
                  alt="Blog"
                />
              </figure>
            </div>
            <div className="right_s">
              <div className="fcComment_box">
                <h2>Author Details</h2>
                <ul className="fcComment_list">
                  <li>
                    <figure>
                      <img
                        src={blog?.authorImage || '/static/images/user_attachment.jpg'}
                        alt={blog?.authorName}
                      />
                    </figure>
                    <p>
                      <b>{blog?.authorName || '-'}</b>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="details_md">
                <h3>Blog Title</h3>
                <p>{blog?.title || '-'}</p>
                <h3>Blog Category</h3>
                <p>{blog?.blogCategory || '-'}</p>
                <h3>Schedule Date and Time</h3>
                <p>{moment(blog?.startDate).format(' lll ') || '-'}</p>
              </div>
            </div>
            <div className="details_md">
              <h3>Blog Description</h3>
              <div dangerouslySetInnerHTML={{ __html: blog?.description }} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
